import { Component } from '@angular/core';
import { ErrorComponent } from '@atoms/error/error.component';

@Component({
  selector: 'edu-general-error-page',
  templateUrl: './general-error.component.html',
  imports: [ErrorComponent],
  standalone: true,
})
export class GeneralErrorPageComponent {}
